import { render, staticRenderFns } from "./DescriptionsList.vue?vue&type=template&id=1ee7738e&scoped=true&"
import script from "./DescriptionsList.vue?vue&type=script&lang=js&"
export * from "./DescriptionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee7738e",
  null
  
)

export default component.exports